import React, { useEffect, useRef, useState } from 'react';
import ApiClient from '../../../methods/api/apiClient';
import Html from './html';
import './style.scss';
import loader from '../../../methods/loader';
import environment from '../../../environment';
import axios from 'axios';
    
const ImageUpload = ({
  model,
  result,
  value,
  multiple,
  required,
  err,
  label = '',
}) => {
  const inputElement = useRef();
  const [img, setImg] = useState('');
  const [loading, setLoader] = useState(false);
  const uploadImage = async (e) => {
    let files = e.target.files;
    let i = 0;
    let imgfile = [];
    for (let item of files) {
      imgfile.push(item);
    }

    let images = [];
    if (img) images = img;
    setLoader(true);
    for await (let item of imgfile) {
      let file = files.item(i);
      let formData = new FormData();
      formData.append('file', file);
      const res = await axios.post(
        `${environment.api}upload/image?modelName=${model||'users'}`,
        formData
      );
      //   const res = await ApiClient.postFormData('upload/image?modelName=users', {
      //     file: file,
      //   });
      try {
        if (res?.data?.success) {
          let image = res?.data?.data?.fullpath;
          if (!multiple) {
            setImg(image);
            result({ event: 'value', value: image });
          } else {
            images.push(image);
          }
        }
      } catch (error) {
        setLoader(false);
        console.log(error)
      }
      
      i++;
    }
    setLoader(false);
    if (multiple) {
      setImg(images);
      result({ event: 'value', value: images });
    }
  };

  const remove = (url, data) => {
    // loader(true);
    // ApiClient.azureBlobDelete({ fileName: value }).then((res) => {
    //   loader(false);

    // ApiClient.delete(`delete/image?modelName=users&Imagename=${url}`).then(
    //   (res) => {
    // if (res?.success) {

    if (!data) setImg('');
    if (data&&multiple) {
      let fltr = data?.filter((itm) => itm != url);
      setImg(fltr);
    }
    setImg('');
    //   }
    // );
    inputElement.current.value = '';
    result({ event: 'remove', value: '' });
    setImg('');
    // });
  };

  useEffect(() => {
    setImg(value);
  }, [value]);

  return (
    <>
      <Html
        label={label}
        multiple={multiple}
        inputElement={inputElement}
        uploadImage={uploadImage}
        img={img}
        model={model}
        required={required}
        loader={loading}
        err={err}
        remove={remove}
      />
    </>
  );
};
export default ImageUpload;
